import { z } from "zod";

/** Every error code the API returns. The web app maps these to messages and states. */
export const errorCodeSchema = z.enum([
  "VALIDATION_FAILED",
  "UNAUTHENTICATED",
  "FORBIDDEN",
  "NOT_FOUND",
  "CONFLICT",
  "PAYLOAD_TOO_LARGE",
  "UPLOAD_TIMEOUT",
  "BUSINESS_RULE",
  "RATE_LIMITED",
  "SERVER_BUSY",
  "IDEMPOTENCY_KEY_REUSED",
  "INTERNAL",
  "WORKSPACE_NOT_FOUND",
  "PROJECT_NOT_FOUND",
  "REPORT_NOT_FOUND",
  "REPORT_EXPIRED",
  "JIRA_NOT_CONNECTED",
  "PUBLIC_LINKS_OFF",
  "MEMBER_NOT_FOUND",
  "INVITE_NOT_FOUND",
  "INVITE_EXPIRED",
  "INVITE_EMAIL_MISMATCH",
  "INVITE_EMAIL_UNVERIFIED",
  "RESET_LINK_NOT_ALLOWED",
  "LAST_OWNER",
  "KEY_PREFIX_TAKEN",
]);

export const apiErrorSchema = z.object({
  error: z.object({
    code: errorCodeSchema,
    message: z.string(),
    requestId: z.string(),
    /** Field-level problems for VALIDATION_FAILED, keyed by dotted path. */
    fields: z.record(z.string(), z.string()).optional(),
  }),
});

export const paginationQuerySchema = z.object({
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});

/** Builds the `{ items, nextCursor }` response schema for a list endpoint. */
export function pageSchema<T extends z.ZodType>(item: T) {
  return z.object({ items: z.array(item), nextCursor: z.string().nullable() });
}

export type ErrorCode = z.infer<typeof errorCodeSchema>;
export type ApiError = z.infer<typeof apiErrorSchema>;
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;
